<script setup lang="ts">
defineSlots<{ default: () => void }>();
</script>

<template>
  <div
    class="bg-client-gray px-r8 lg:px-r16 pt-r12 lg:pt-r18 gap-r18 flex flex-col overflow-hidden rounded-lg"
  >
    <slot />
    <SVGLogoFooterText class="lg:pt-r18 self-center" />
  </div>
</template>
